import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { ToolTip, Icon } from "@lifepay/rc-ui-toolkit";
import hintSVG from "@lifepay/assets/sprites/feather/core/info.svg";
import codes from "data/currency-codes.json";
import styles from "./HintedCurrencyCode.m.scss";

function HintedCurrencyCode(props) {
  const { theme, code } = props;

  return (
    <div className={classnames(theme.wrapper)}>
      {code}
      <ToolTip type={"info"} dataTip={codes[code]}>
        <Icon
          sprite={hintSVG}
          size={"smallest"}
          theme={{
            wrapper: theme["icon-wrapper"],
          }}
        />
      </ToolTip>
    </div>
  );
}

HintedCurrencyCode.displayName = "HintedCurrencyCode";

HintedCurrencyCode.propTypes = {
  theme: PropTypes.object,
  code: PropTypes.string,
};

HintedCurrencyCode.defaultProps = {};
export default themr("@lifepay/HintedCurrencyCode", styles)(HintedCurrencyCode);



// WEBPACK FOOTER //
// ./src/components/utils/HintedCurrencyCode/HintedCurrencyCode.js